import request from '@/lib/request'

export const login = (form: CustomRequest.LoginForm) => {
  return request<CustomResponse.LoginResponse>({
    url: '/auth/login',
    method: 'post',
    data: form
  })
}

export const fetchGetUserInfo = () => {
  return request<CustomResponse.UserInfo>({
    url: '/auth/getUserInfo',
    method: 'get'
  })
}

export const fetchGetUserList = () => {
  return request<CustomResponse.UserItem[]>({
    url: '/auth/getUserList',
    method: 'get'
  })
}

export const fetchAddUser = (data: CustomRequest.LoginForm) => {
  return request<null>({
    url: '/auth/addUser',
    method: 'put',
    data
  })
}

export const fetchChangeUser = (data: CustomRequest.ChangeUserForm) => {
  return request<null>({
    url: '/auth/changeUser',
    method: 'post',
    data
  })
}

export const fetchDeleteUser = (data: number[]) => {
  return request<null>({
    url: '/auth/deleteUser',
    method: 'delete',
    data
  })
}
